import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import ValidateForm from '../../../../../../app/components/common/ValidateForm'

class Email extends Component {
  state = {
    isBillAddressAutoValidate: false,
    isPhoneAutoValidate: false
  }

  hasError() {
    return (
      this.refs.billAddress.validate().hasError ||
      this.refs.phone.validate().hasError
    )
  }

  render() {
    const {
      billAddress,
      phone,
      onChangeBillAddress,
      onChangePhone
    } = this.props

    return (
      <div>
        <FormattedMessage
          id="Fill in your email address to receive an electronic fapiao by email"
        >
          {text => <p className="light">{text}</p>}
        </FormattedMessage>
        <ValidateForm
          ref="billAddress"
          autoValidate={this.state.isBillAddressAutoValidate}
        >
          <input
            name="billAddress"
            type="text"
            value={billAddress}
            onChange={e => {
              onChangeBillAddress(e.target.value)
            }}
            onBlur={() => {
              if (!this.state.isBillAddressAutoValidate) {
                this.setState({ isBillAddressAutoValidate: true })
              }
            }}
            placeholder={this.props.intl.formatMessage({ id: 'Email Address' })}
            data-error-isRequired
            data-error-isEmail
          />
        </ValidateForm>
        <ValidateForm ref="phone" autoValidate={this.state.isPhoneAutoValidate}>
          <input
            name="phone"
            type="text"
            pattern="\d*"
            value={phone}
            onChange={e => {
              if (/^\d{0,11}$/.test(e.target.value)) {
                onChangePhone(e.target.value)
              }
            }}
            onBlur={() => {
              if (!this.state.isPhoneAutoValidate) {
                this.setState({ isPhoneAutoValidate: true })
              }
            }}
            placeholder={this.props.intl.formatMessage({ id: 'Mobile Number' })}
            data-error-isRequired
            data-error-isPhone
          />
        </ValidateForm>
      </div>
    )
  }
}

export default Email
